import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .modal-delete {
    .btn-guardar {
      border: 1px solid var(--pink-contentoh);
      background: var(--pink-contentoh);
      color: var(--white-contentoh);
      border-radius: 30px;
      padding: 4px 8px;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        border: 1px solid var(--pink-contentoh);
        background: var(--white-contentoh);
        color: var(--pink-contentoh);
      }
    }
    .btn-cancelar {
      border: 1px solid var(--pink-contentoh);
      background: var(--white-contentoh);
      color: var(--pink-contentoh);
      border-radius: 30px;
      cursor: pointer;
      padding: 4px 8px;
      &:hover {
        border: 1px solid var(--pink-contentoh);
        background: var(--pink-contentoh);
        color: var(--white-contentoh);
      }
    }
  }
  .modal-update {
    .custom-component {
      margin-top: 10px;
    }
    .input-wishlist{
      width: 100%;
      height: 28px;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
      padding: 7px;
      box-sizing: border-box;
      border-radius: 6px;
      border: 1px solid rgb(204, 204, 204);
    }
    .btn-guardar {
      border: 1px solid var(--pink-contentoh);
      background: var(--pink-contentoh);
      color: var(--white-contentoh);
      border-radius: 30px;
      padding: 4px 8px;
      cursor: pointer;
      font-size: 12px;
      &:hover {
        border: 1px solid var(--pink-contentoh);
        background: var(--white-contentoh);
        color: var(--pink-contentoh);
      }
    }
    .btn-cancelar {
      border: 1px solid var(--pink-contentoh);
      background: var(--white-contentoh);
      color: var(--pink-contentoh);
      border-radius: 30px;
      cursor: pointer;
      padding: 4px 8px;
      &:hover {
        border: 1px solid var(--pink-contentoh);
        background: var(--pink-contentoh);
        color: var(--white-contentoh);
      }
    }
  }
`;
